import { createContentPropTypes } from '../../../../helpers/content';

const content = {
	rateNeedsRefreshedBtn: 'Get Rate and Fees',
	rateNeedsRefreshedMessage: 'Payment information has changed - please hit the button to fetch new rates.',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
